import React from "react";
import "./App.css";
import Main from "./containers/Main";

function App() {
  return <Main />;
}

export default App;
